import React from "react";
import SimulationLayout from "./simulation-layout";

export default class Simulation extends React.Component<any> {
  render() {
    const { setGuideLine } = this.props;
    return <SimulationLayout setGuideLine={setGuideLine} />;
  }
}